import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#fff",
    padding: 20,
  },
  topHeader: {
    height: 75,
  },
  shippingDescription: {
    marginVertical: 5,
  },
  headingMain: { fontSize: 20, fontWeight: "extrabold" },
  headingSecond: { fontSize: 12, fontWeight: "extrabold" },
  headingThird: { fontSize: 15, fontWeight: "extrabold" },
  textbody: { fontSize: 12 },
  mainContainer: {
    marginBottom: "20px",
    flexDirection: "column",
    border: "1px solid grey",
  },
  prodTitle: {
    width: "100%",
    textAlign: "left",
    padding: "5px 10px",

    borderBottom: "1px solid grey",
    fontSize: "14px",
  },
  prodMain: {
    width: "100%",
    flexDirection: "row",
  },
  prodContent: {
    flexGrow: 1,
  },
  prodSizes: {
    padding: "5px",
    width: "150px",
    borderLeft: "1px solid grey",
  },
  prodInfoRow: {
    display: "flex",
    flexDirection: "row",
    fontSize: "10px",
  },
  prodCol: {
    display: "flex",
    flexDirection: "row",
    width: "50%",
  },
  prodKey: {
    padding: "3px 5px",
    width: "40%",
    borderRight: "1px solid grey",
    borderBottom: "1px solid grey",
  },
  prodVal: {
    padding: "3px 5px",
    width: "60%",
    borderBottom: "1px solid grey",
  },
  prodComments: {
    padding: "5px 10px",
    fontSize: "12px",
    borderTop: "1px solid grey",
  },
  prodSubHeading: {
    fontSize: "12px",
  },
  prodTxt: {
    fontSize: "10px",
  },
  borderRight: { borderRight: "1px solid grey" },
  colWithLong: {
    width: "200px",
    marginTop: 5,
    marginBottom: 3,
  },
  colWith: {
    width: "60px",
    marginTop: 5,
    marginBottom: 3,
    marginHorizontal: 5,
  },
  colWithSm: {
    width: "30px",
    marginTop: 5,
    marginBottom: 3,
  },
  colWithXs: {
    width: "10px",
    marginTop: 5,
    marginBottom: 3,
  },
});

// Create Document Component
export const PurchaseReportPdf = ({ reportData }) => {
  /*   ALL STATES
   ********************************************* */

  /*   ALL FUnctions
   ********************************************* */

  const getCurrentDate = () => {
    const currentDate = new Date();
    const date = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    const formattedDate = date + "-" + month + "-" + year;
    return formattedDate;
  };

  const getCurrentTime = () => {
    const currentDate = new Date();

    let hours = currentDate.getHours();
    const minutes = currentDate.getMinutes();

    const amPm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12;
    hours = hours ? hours : 12; // If hours is 0, set it to 12

    // Add leading zeros to hours and minutes
    const formattedHours = hours.toString().padStart(2, "0");
    const formattedMinutes = minutes.toString().padStart(2, "0");

    const formattedTime = formattedHours + ":" + formattedMinutes + " " + amPm;

    return formattedTime;
  };

  const getIssueQty = (item) => {
    let issueQty = item?.m_issues
      ?.reduce((acc, item) => acc + item.qty, 0)
      ?.toFixed(3);

    if (issueQty === "0.000") {
      return "0";
    }
    return issueQty || 0;
  };

  return (
    <Document title={"Inventory External Transaction Report"}>
      <Page size="LETTER" orientation="landscape" style={styles.page}>
        {/*   Header
         ********************************************* */}
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "space-between",
            marginBottom: 20,
          }}
        >
          <View>
            <Text style={{ fontSize: 20 }}>Purchase History Report </Text>
          </View>
          <View style={{ flexDirection: "row", gap: 15, alignItems: "center" }}>
            <Text style={{ fontSize: 15 }}>Date : {getCurrentDate()}</Text>
            <Text style={{ fontSize: 15 }}>Time : {getCurrentTime()}</Text>
          </View>
        </View>
        <View style={{ marginTop: "5px" }}>
          {/*   Table Head
           ********************************************* */}
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-end",
              borderBottom: "2px solid gray",

              paddingHorizontal: 10,
            }}
          >
            <View style={{ width: "15%" }}>
              <Text style={styles.textbody}>T-ID</Text>
            </View>
            <View style={{ width: "15%" }}>
              <Text style={styles.textbody}>Lot#</Text>
            </View>
            <View style={{ width: "35%" }}>
              <Text style={styles.textbody}>Material</Text>
            </View>
            <View style={{ width: "40%" }}>
              <Text style={styles.textbody}>Vendor</Text>
            </View>
            <View style={{ width: "35%" }}>
              <Text style={styles.textbody}>Original Qty</Text>
            </View>
            <View style={{ width: "35%" }}>
              <Text style={styles.textbody}>Return Qty</Text>
            </View>
            <View style={{ width: "35%" }}>
              <Text style={styles.textbody}>Issue Qty</Text>
            </View>
            <View style={{ width: "35%" }}>
              <Text style={styles.textbody}>Available Qty</Text>
            </View>
            <View style={{ width: "35%" }}>
              <Text style={styles.textbody}>Unit Price</Text>
            </View>
            <View style={{ width: "35%" }}>
              <Text style={styles.textbody}>Lot Price</Text>
            </View>
          </View>
          {/*   Table Body
           ********************************************* */}
          {reportData.map((item) => (
            <View
              key={item?.id}
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid gray",

                paddingHorizontal: 10,
              }}
            >
              <View style={{ width: "15%" }}>
                <Text style={styles.textbody}>{item?.tid}</Text>
              </View>

              <View style={{ width: "15%" }}>
                <Text style={styles.textbody}>{item?.lotId}</Text>
              </View>
              <View style={{ width: "35%" }}>
                <Text style={styles.textbody}>{item?.styleId}</Text>
              </View>
              <View style={{ width: "40%" }}>
                <Text style={styles.textbody}>
                  {item?.vendorName?.length > 10
                    ? item?.vendorName.slice(0, 10) + "..."
                    : item?.vendorName}
                </Text>
              </View>
              <View style={{ width: "35%" }}>
                <Text style={styles.textbody}>{item?.purchasedQty}</Text>
              </View>
              <View style={{ width: "35%" }}>
                <Text style={styles.textbody}>{item?.returnQty || 0}</Text>
              </View>
              <View style={{ width: "35%" }}>
                <Text style={styles.textbody}>{getIssueQty(item)}</Text>
              </View>
              <View style={{ width: "35%" }}>
                <Text style={styles.textbody}>{item?.qty}</Text>
              </View>
              <View style={{ width: "35%" }}>
                <Text style={styles.textbody}>
                  {item?.unitPrice?.toFixed(2)}
                </Text>
              </View>
              <View style={{ width: "35%" }}>
                <Text style={styles.textbody}>
                  {item?.lotTotalPrice?.toFixed(2)}
                </Text>
              </View>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
};
